<template>
  <el-drawer
    v-if="visible"
    :title="title"
    :visible="visible"
    direction="rtl"
    :size="'80%'"
    show-close
    @close="close"
    :before-close="handleClose"
    append-to-body
  >
    <div class="drawer-main">
      <EditForm
        ref="editForm"
        :mrpOutsourcingOrderCode="mrpOutsourcingOrderCode"
        :disabled="disabled"
        @reload="$emit('reload')"
        @close="close()"
      />
    </div>
  </el-drawer>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    mrpOutsourcingOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    handleClose(done) {
      if (this.disabled) {
        done()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 32px;
}
</style>
